/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventIndex: NonNullable<unknown> }} Event_Original_Text_Editor_Aria_LabelInputs */

const en_event_original_text_editor_aria_label = /** @type {(inputs: Event_Original_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
};

const fr_event_original_text_editor_aria_label = /** @type {(inputs: Event_Original_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
};

const de_event_original_text_editor_aria_label = /** @type {(inputs: Event_Original_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
};

const it_event_original_text_editor_aria_label = /** @type {(inputs: Event_Original_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
};

const ru_event_original_text_editor_aria_label = /** @type {(inputs: Event_Original_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
};

const es_event_original_text_editor_aria_label = /** @type {(inputs: Event_Original_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
};

const zh_cn2_event_original_text_editor_aria_label = /** @type {(inputs: Event_Original_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
};

const ja_event_original_text_editor_aria_label = /** @type {(inputs: Event_Original_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
};

const hi_event_original_text_editor_aria_label = /** @type {(inputs: Event_Original_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
};

const pt_pt2_event_original_text_editor_aria_label = /** @type {(inputs: Event_Original_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original text editor for event ${i?.eventIndex}`)
};

/**
* | output |
* | --- |
* | "Original text editor for event {eventIndex}" |
*
* @param {Event_Original_Text_Editor_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_original_text_editor_aria_label = /** @type {((inputs: Event_Original_Text_Editor_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Original_Text_Editor_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_original_text_editor_aria_label(inputs)
	if (locale === "de") return de_event_original_text_editor_aria_label(inputs)
	if (locale === "it") return it_event_original_text_editor_aria_label(inputs)
	if (locale === "ru") return ru_event_original_text_editor_aria_label(inputs)
	if (locale === "es") return es_event_original_text_editor_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_original_text_editor_aria_label(inputs)
	if (locale === "ja") return ja_event_original_text_editor_aria_label(inputs)
	if (locale === "hi") return hi_event_original_text_editor_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_original_text_editor_aria_label(inputs)
	return en_event_original_text_editor_aria_label(inputs)
});